import { useSelector } from 'react-redux'

import { RootState } from '../../../reducers'
import { isIntentExpandedForIdSelector } from '../selectors'

export function useIsIntentExpandedForId(intentId: string) {
  return useSelector<RootState, boolean>(state => isIntentExpandedForIdSelector(state, intentId))
}
